module.exports = __webpack_public_path__ + "static/media/upload-autosign.f1f6f8f9.svg";